import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Mail, Plus, X } from "lucide-react";

export const ReportRecipients = () => {
  const [adminEmail, setAdminEmail] = useState("");
  const [emails, setEmails] = useState([]);
  const [draft, setDraft] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings/report-recipients").then((r) => { setAdminEmail(r.data.admin_email); setEmails(r.data.emails); });
  }, []);

  const save = async (next) => {
    setSaving(true);
    try {
      const r = await api.put("/settings/report-recipients", { emails: next });
      setEmails(r.data.emails);
      toast.success("Rapor alıcıları kaydedildi");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Kaydedilemedi");
    } finally { setSaving(false); }
  };

  const add = () => {
    const v = draft.trim().toLowerCase();
    if (!v || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return toast.error("Geçerli bir e-posta girin");
    if (v === adminEmail || emails.includes(v)) return toast.error("Bu adres zaten listede");
    setDraft("");
    save([...emails, v]);
  };

  return (
    <section className="rounded-2xl border border-border bg-card p-5" data-testid="report-recipients">
      <div className="mb-3 flex items-center gap-2">
        <Mail className="h-4 w-4 text-primary" />
        <h2 className="font-heading text-base font-bold md:text-lg">Gece Z Raporu Alıcıları</h2>
      </div>
      <p className="mb-4 text-sm text-muted-foreground">Genel (tüm kullanıcılar) rapor her gün seçilen saatte (varsayılan 23:00) aşağıdaki adreslere gönderilir. Her kullanıcı ayrıca kendi verilerini içeren raporu profil e-postasına alır.</p>
      <ul className="mb-4 space-y-2">
        <li className="flex items-center justify-between rounded-lg bg-secondary/60 px-3 py-2 text-sm" data-testid="recipient-admin">
          <span>{adminEmail}</span><span className="text-xs text-muted-foreground">Yönetici (sabit)</span>
        </li>
        {emails.map((e) => (
          <li key={e} className="flex items-center justify-between rounded-lg bg-secondary/40 px-3 py-2 text-sm" data-testid={`recipient-${e}`}>
            <span>{e}</span>
            <Button size="icon" variant="ghost" className="h-7 w-7" disabled={saving} data-testid={`recipient-remove-${e}`} onClick={() => save(emails.filter((x) => x !== e))}><X className="h-4 w-4" /></Button>
          </li>
        ))}
      </ul>
      <div className="flex gap-2">
        <Input type="email" placeholder="ornek@eposta.com" value={draft} data-testid="recipient-input"
          onChange={(e) => setDraft(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} />
        <Button onClick={add} disabled={saving} data-testid="recipient-add"><Plus className="mr-1 h-4 w-4" /> Ekle</Button>
      </div>
    </section>
  );
};
